"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
const DialogWrapper = styled_components_1.default.div `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const DialogContainer = styled_components_1.default.div `
  margin-top: auto;
  background-color: ${props => props.theme.palette.BW_100};
  max-width: ${props => props.theme.constants.loginModalWidth.lg}px;
  width: 100%;
  padding: 24px;
  position: relative;
`;
const CloseButton = styled_components_1.default.button `
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;

  > svg {
    > path {
      fill: ${props => props.theme.palette.BLUE_GRAY_40};
    }
  }
`;
const Title = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0 0 12px;
  font-size: 20px;
`;
const Message = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0 0 24px;
  font-size: 16px;
`;
exports.default = {
    DialogContainer,
    CloseButton,
    Title,
    Message,
    DialogWrapper
};
